import React from "react";
import { FaRegBell } from "react-icons/fa";

export const AppTopbar = (props) => {
  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };
  return (
    <div className="layout-topbar clearfix">
      <button
        type="button"
        className="p-link layout-menu-button"
        onClick={props.onToggleMenu}
      >
        <span className="pi pi-bars" />
      </button>

      <div className="layout-topbar-icons" style={{ display: "flex" }}>
        <button type="button" className="p-link">
          <span onClick={handleLogout} className="layout-topbar-item-text">
            <span className="logout">Logout</span>
          </span>
        </button>
      </div>
    </div>
  );
};
